import { Component } from '@angular/core';

@Component({
  selector: 'app-ex-register',
  templateUrl: './ex-register.component.html',
  styleUrls: ['./ex-register.component.css']
})
export class ExRegisterComponent {

}
